<!-- ══════════════════════════════════════════════════════════════════════════
     «ASISTENTE DE IA» — solapa de la ficha del comercio.
     🔴 RUTA HIJA: la miga, el nombre, la tira del portal y las solapas los pone
     el padre (`comercios-detail`). Aquí sólo lo de esta solapa.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="space-y-8">

  <!-- Las acciones, a la derecha y con aire (mismo gesto que Tiendas y Contactos). Quien no
       configura ve, a la izquierda, que está en sólo lectura. -->
  <div class="flex flex-wrap items-center justify-end gap-2 pt-2">
    <p class="m-0 mr-auto flex items-center gap-2 text-sm text-muted-foreground" *ngIf="!puedeEditar" role="status">
      <i class="fas fa-eye" aria-hidden="true"></i>Estás viendo en modo de sólo lectura.
    </p>
    <a class="kb-btn kb-btn-outline" [routerLink]="['/console/ia', 'bitacora']" [queryParams]="{ comercio: codigo }">
      <i class="fas fa-stream !text-foreground" aria-hidden="true"></i>Ver en la bitácora
    </a>
    <a class="kb-btn kb-btn-primary" [routerLink]="['/console/ia', 'probar']" [queryParams]="{ comercio: codigo }">
      <i class="fas fa-vial" aria-hidden="true"></i>Probar como este comercio
    </a>
  </div>

  <!-- ── Cargando ── -->
  <div *ngIf="cargando" class="space-y-4" aria-live="polite" aria-busy="true">
    <div class="kb-skeleton h-28 w-full rounded-xl"></div>
    <div class="kb-stat-grid"><div class="kb-skeleton h-24 w-full rounded-xl" *ngFor="let s of [1,2,3,4]"></div></div>
    <div class="kb-skeleton h-48 w-full rounded-xl"></div>
  </div>

  <!-- ── No se pudo leer ── -->
  <div class="kb-tira" *ngIf="!cargando && error" role="alert">
    <p class="m-0 text-sm">
      <i class="fas fa-exclamation-circle mr-1.5 text-destructive" aria-hidden="true"></i>
      No se pudo leer el asistente de este comercio. <span class="text-muted-foreground">{{ error }}</span>
    </p>
    <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="cargar()">
      <i class="fas fa-redo !text-foreground" aria-hidden="true"></i>Reintentar
    </button>
  </div>

  <ng-container *ngIf="!cargando && ia">

    <!-- ══ EL INTERRUPTOR DEL COMERCIO ════════════════════════════════════════ -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <div class="flex items-start gap-4">
          <div class="pt-0.5">
            <app-ia-interruptor [encendido]="ia.habilitado" [deshabilitado]="!puedeEditar" [ocupado]="cambiando"
                                [etiqueta]="ia.habilitado ? 'Apagar el asistente de este comercio' : 'Prender el asistente de este comercio'"
                                (cambiar)="alternar($event)"></app-ia-interruptor>
          </div>
          <div class="min-w-0">
            <h2 class="flex flex-wrap items-center gap-2 text-base font-semibold leading-none">
              Asistente de IA
              <span class="kb-badge kb-badge-exito" *ngIf="ia.habilitado"><i class="fas fa-check-circle" aria-hidden="true"></i>Prendido</span>
              <span class="kb-badge kb-badge-neutro" *ngIf="!ia.habilitado"><i class="fas fa-pause-circle" aria-hidden="true"></i>Apagado</span>
            </h2>
            <p class="m-0 mt-2 text-sm text-muted-foreground">
              {{ ia.habilitado
                 ? 'El administrador del comercio ve el botón del asistente en su portal y le puede preguntar por sus ventas, órdenes, turnos, liquidaciones y su ficha.'
                 : 'Nadie de este comercio lo ve. Nace apagado: se prende aquí cuando CrediTotal lo decide.' }}
              Caja, ventas, gerente y técnico no lo ven nunca.
            </p>
            <p class="m-0 mt-2 text-sm kb-texto-alerta" *ngIf="ia.habilitado && impedimentos.length">
              <i class="fas fa-exclamation-triangle mr-1" aria-hidden="true"></i>Hoy igual no le aparece: {{ impedimentos.join('; ') }}.
            </p>
            <p class="kb-error m-0 mt-2" *ngIf="errorInterruptor" role="alert">{{ errorInterruptor }}</p>
            <p class="m-0 mt-2 text-xs text-muted-foreground" *ngIf="ia.actualizadoPor || ia.actualizadoEl">
              Último cambio: {{ ia.actualizadoEl ? fechaHora(ia.actualizadoEl) : '' }}{{ ia.actualizadoPor ? ' · ' + ia.actualizadoPor : '' }}
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- ══ LAS CUATRO CIFRAS ═════════════════════════════════════════════════ -->
    <div class="kb-stat-grid">
      <div class="kb-stat">
        <span class="kb-stat-label block">Gasto de hoy</span>
        <span class="kb-stat-valor block">{{ usd(ia.gastoHoyUsd) }}</span>
        <span class="kb-stat-pie block">
          {{ ia.topeDiarioUsd !== null && ia.topeDiarioUsd !== undefined ? 'de ' + usd(ia.topeDiarioUsd) + ' de tope propio' : 'sin tope propio' }}
        </span>
      </div>
      <div class="kb-stat">
        <span class="kb-stat-label block">Gasto en 7 días</span>
        <span class="kb-stat-valor block">{{ gasto7d !== null ? usd(gasto7d) : '—' }}</span>
        <span class="kb-stat-pie block">{{ gasto7d !== null ? 'preguntas y pruebas' : 'no se pudo calcular' }}</span>
      </div>
      <div class="kb-stat">
        <span class="kb-stat-label block">Preguntas hoy</span>
        <span class="kb-stat-valor block">{{ nf(ia.preguntasHoy) }}</span>
        <span class="kb-stat-pie block">del administrador, en su portal</span>
      </div>
      <div class="kb-stat">
        <span class="kb-stat-label block">Preguntas en 7 días</span>
        <span class="kb-stat-valor block">{{ nf(ia.preguntas7d) }}</span>
        <span class="kb-stat-pie block">del administrador, en su portal</span>
      </div>
    </div>

    <!-- ══ EL TOPE PROPIO ════════════════════════════════════════════════════
         Un renglón: es un número y su botón. A lo ancho, la tabla de claves de abajo
         cabe entera; apretadas en dos columnas, sus botones se salían de la tarjeta. -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <div>
          <h2 class="flex items-center gap-2 text-base font-semibold leading-none">
            <i class="fas fa-tachometer-alt text-muted-foreground" aria-hidden="true"></i>Tope diario propio
          </h2>
          <p class="m-0 mt-2 text-sm text-muted-foreground">
            Cuánto puede gastar este comercio en un día. Vacío: sin tope propio, y manda el de plataforma<ng-container
              *ngIf="estado"> ({{ usd(estado.topeDiarioUsd) }} entre todos)</ng-container>.
          </p>
        </div>
      </div>
      <div class="kb-tarjeta-cuerpo">
        <form class="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-end" (ngSubmit)="guardarTope()">
          <div class="w-full sm:w-56">
            <label class="kb-label" for="asis-tope">En dólares</label>
            <input id="asis-tope" name="tope" class="kb-input" type="number" min="0" step="0.01" inputmode="decimal"
                   placeholder="Sin tope propio" [(ngModel)]="tope" [disabled]="!puedeEditar"
                   [class.kb-input-invalido]="!topeValido">
          </div>
          <div class="flex flex-wrap items-center gap-2" *ngIf="puedeEditar">
            <button type="submit" class="kb-btn kb-btn-primary" [disabled]="guardandoTope || !topeCambiado || !topeValido">
              <i class="fas" [ngClass]="guardandoTope ? 'fa-circle-notch fa-spin' : 'fa-save'" aria-hidden="true"></i>Guardar el tope
            </button>
            <button type="button" class="kb-btn kb-btn-ghost" *ngIf="ia.topeDiarioUsd !== null && ia.topeDiarioUsd !== undefined"
                    [disabled]="guardandoTope" (click)="guardarTope(true)">Quitar el tope propio</button>
          </div>
          <p class="m-0 text-sm sm:pb-2" *ngIf="resultadoTope" role="status"
             [ngClass]="resultadoTope.ok ? 'kb-texto-exito' : 'kb-texto-peligro'">{{ resultadoTope.texto }}</p>
        </form>
      </div>
    </section>

    <!-- ══ LA CLAVE PROPIA ═══════════════════════════════════════════════════ -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <div>
          <h2 class="flex items-center gap-2 text-base font-semibold leading-none">
            <i class="fas fa-key text-muted-foreground" aria-hidden="true"></i>Clave propia
          </h2>
          <p class="m-0 mt-2 text-sm text-muted-foreground">
            Opcional. Si la tiene, el asistente de este comercio la usa en lugar de la de plataforma.
          </p>
        </div>
      </div>
      <div class="kb-tarjeta-cuerpo">
        <app-ia-credenciales [comercio]="codigo" [estado]="estado" [puedeEditar]="puedeEditar"
                             (cambio)="releerEstado()"></app-ia-credenciales>
      </div>
    </section>

    <!-- ══ LAS ÚLTIMAS 20 PREGUNTAS ══════════════════════════════════════════ -->
    <section class="kb-tarjeta">
      <div class="kb-tarjeta-cab">
        <div>
          <h2 class="flex items-center gap-2 text-base font-semibold leading-none">
            <i class="fas fa-comments text-muted-foreground" aria-hidden="true"></i>Últimas preguntas
          </h2>
          <p class="m-0 mt-2 text-sm text-muted-foreground">
            Las 20 más recientes, con lo que se le contestó. Abre la fila para ver la respuesta entera.
          </p>
        </div>
      </div>
      <div class="kb-tarjeta-cuerpo">
        <div class="kb-empty" *ngIf="!ultimas.length">
          <span class="kb-empty-icono"><i class="fas fa-comments" aria-hidden="true"></i></span>
          <p class="kb-empty-titulo">Todavía no preguntó nada</p>
          <p class="kb-empty-texto">Cuando su administrador le pregunte al asistente, o lo pruebes desde aquí, aparece en esta lista.</p>
        </div>

        <div class="kb-tabla-plana" *ngIf="ultimas.length">
          <table class="kb-table">
            <thead class="kb-thead">
              <tr>
                <th class="kb-th">Cuándo</th>
                <th class="kb-th">Quién</th>
                <th class="kb-th">Pregunta</th>
                <th class="kb-th">Tipo</th>
                <th class="kb-th">Cómo terminó</th>
                <th class="kb-th kb-th-num">Costo</th>
                <th class="kb-th w-8"><span class="sr-only">Abrir</span></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let r of ultimas; let i = index">
                <tr class="kb-tr kb-tr-clic" tabindex="0" role="button" [attr.aria-expanded]="abierta === idDe(r, i)"
                    (click)="alternarFila(r, i)" (keydown.enter)="alternarFila(r, i)">
                  <td class="kb-td whitespace-nowrap text-xs text-muted-foreground" [title]="fechaHora(r.creadoEl)">{{ fechaCorta(r.creadoEl) }}</td>
                  <td class="kb-td whitespace-nowrap">{{ r.usuario || '—' }}</td>
                  <td class="kb-td">
                    <span class="line-clamp-2 min-w-[12rem]" *ngIf="r.pregunta">{{ r.pregunta }}</span>
                    <span class="line-clamp-2 min-w-[12rem] text-muted-foreground" *ngIf="!r.pregunta">{{ motivoLegible(r.motivo) || '—' }}</span>
                  </td>
                  <td class="kb-td whitespace-nowrap">{{ etiquetaFila(r) }}</td>
                  <td class="kb-td"><span class="kb-badge" [ngClass]="BADGE_ESTADO[r.estado] || 'kb-badge-neutro'">{{ ETIQUETA_ESTADO[r.estado] || r.estado }}</span></td>
                  <td class="kb-td kb-td-num whitespace-nowrap" [title]="usd(r.costoUsd)">{{ usdCorto(r.costoUsd) }}</td>
                  <td class="kb-td">
                    <i class="fas fa-chevron-right text-xs text-muted-foreground transition-transform"
                       [class.rotate-90]="abierta === idDe(r, i)" aria-hidden="true"></i>
                  </td>
                </tr>
                <tr *ngIf="abierta === idDe(r, i)">
                  <td class="kb-td kb-fondo-suave" colspan="7">
                    <app-ia-registro [registro]="r"></app-ia-registro>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  </ng-container>
</div>
